import Header from "../../components/feature/Header";
import Breadcrumbs from "../../components/feature/Breadcrumbs";
import Footer from "../../components/feature/Footer";
import WhatsAppFloating from "../../components/feature/WhatsAppFloating";
import CookieBanner from "../../components/feature/CookieBanner";
import SEO from "../../components/feature/SEO";
import { useNoIndex } from "../../hooks/useNoIndex";

export default function AvisoLegal() {
  useNoIndex();

  return (
    <div className="min-h-screen bg-white">
      <SEO ogImage="https://persianas-toldos-malaga.es/og/og-default.jpg" ogType="website" />
      <Header />
      <Breadcrumbs />
      <main>
        <section className="py-16 md:py-24">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <h1 className="font-heading font-extrabold text-3xl md:text-4xl text-text-primary mb-3">
              Aviso Legal
            </h1>
            <p className="font-body text-base text-text-secondary mb-12">
              Información legal sobre el titular del sitio web y condiciones de uso.
            </p>

            <div className="space-y-10 font-body text-base text-text-secondary leading-relaxed">
              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  1. Datos identificativos del titular
                </h2>
                <p className="mb-2">
                  De conformidad con lo dispuesto en el artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSI-CE), se informa a los usuarios de que el titular de este sitio web es:
                </p>
                <ul className="list-disc pl-6 space-y-1.5 mt-3">
                  <li><strong className="text-text-primary">Denominación social:</strong> Persianas Toldos Málaga</li>
                  <li><strong className="text-text-primary">Domicilio social:</strong> Calle Pacífico 54, 29003 Málaga, España</li>
                  <li><strong className="text-text-primary">Teléfono:</strong> +34 951 12 07 70</li>
                  <li><strong className="text-text-primary">Correo electrónico:</strong> info@persianas-toldos-malaga.es</li>
                  <li><strong className="text-text-primary">CIF:</strong> B93847562</li>
                  <li><strong className="text-text-primary">Sitio web:</strong> persianas-toldos-malaga.es</li>
                </ul>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  2. Objeto y ámbito de aplicación
                </h2>
                <p className="mb-2">
                  El presente sitio web tiene por objeto facilitar a los usuarios información sobre los servicios de reparación, instalación y motorización de persianas, toldos y mosquiteras que presta Persianas Toldos Málaga en la provincia de Málaga y la Costa del Sol.
                </p>
                <p className="mb-2">
                  El acceso y navegación por este sitio web implica la aceptación expresa de las presentes condiciones, así como de la Política de Privacidad y la Política de Cookies. En caso de no estar de acuerdo con las mismas, se recomienda abandonar el sitio web.
                </p>
                <p>
                  Persianas Toldos Málaga se reserva el derecho a modificar unilateralmente las presentes condiciones en cualquier momento, notificando al usuario de dichos cambios mediante su publicación en esta misma sección.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  3. Acceso y uso del sitio web
                </h2>
                <p className="mb-2">
                  El acceso a este sitio web es gratuito y no requiere registro previo, salvo en aquellas secciones en las que se solicite expresamente la cumplimentación de un formulario de contacto.
                </p>
                <p className="mb-2">
                  El usuario se compromete a utilizar el sitio web de forma diligente, correcta y lícita, absteniéndose de:
                </p>
                <ul className="list-disc pl-6 space-y-1.5 mt-2">
                  <li>Realizar actividades ilícitas, ilegales o contrarias a la buena fe y al orden público.</li>
                  <li>Difundir contenidos de carácter racista, xenófobo, pornográfico o que atenten contra los derechos fundamentales.</li>
                  <li>Provocar daños en los sistemas físicos o lógicos de Persianas Toldos Málaga, de sus proveedores o de terceros.</li>
                  <li>Introducir o difundir virus informáticos o cualquier otro sistema susceptible de provocar daños en los equipos.</li>
                  <li>Intentar acceder, utilizar o manipular los datos de otros usuarios sin autorización expresa.</li>
                </ul>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  4. Propiedad intelectual e industrial
                </h2>
                <p className="mb-2">
                  Todos los contenidos de este sitio web, incluyendo textos, fotografías, gráficos, logotipos, iconos, software, bases de datos, código fuente, estructura de navegación y diseño visual, son propiedad exclusiva de Persianas Toldos Málaga o de terceros que han autorizado su uso, y están protegidos por las leyes españolas e internacionales de propiedad intelectual e industrial.
                </p>
                <p className="mb-2">
                  Queda expresamente prohibida la reproducción, distribución, comunicación pública, transformación o cualquier otro uso de los contenidos de este sitio web sin la autorización previa y por escrito del titular.
                </p>
                <p>
                  Las marcas registradas, nombres comerciales y signos distintivos que aparecen en este sitio web son titularidad de Persianas Toldos Málaga o de sus respectivos propietarios. El acceso al sitio web no otorga al usuario ningún derecho sobre dichos signos distintivos.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  5. Responsabilidad
                </h2>
                <p className="mb-2">
                  Persianas Toldos Málaga no garantiza la inexistencia de errores en el acceso al sitio web, en su contenido ni en su actualización, aunque pondrá su máximo empeño para evitarlos y subsanarlos a la mayor brevedad.
                </p>
                <p className="mb-2">
                  El titular no se hace responsable de los daños o perjuicios de cualquier naturaleza que pudieran derivarse de:
                </p>
                <ul className="list-disc pl-6 space-y-1.5 mt-2">
                  <li>La interrupción del funcionamiento o la falta de disponibilidad del sitio web.</li>
                  <li>La presencia de virus o cualquier otro elemento informático dañino en los contenidos.</li>
                  <li>El uso incorrecto o ilícito del sitio web por parte del usuario.</li>
                  <li>La falta de veracidad, exactitud o actualidad de los contenidos proporcionados por terceros.</li>
                </ul>
                <p className="mt-3">
                  Asimismo, Persianas Toldos Málaga no se responsabiliza de los contenidos, servicios, productos o información ofrecidos por terceros a través de enlaces que puedan aparecer en este sitio web.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  6. Enlaces a sitios de terceros
                </h2>
                <p className="mb-2">
                  Este sitio web puede contener enlaces a sitios web de terceros, incluyendo Google Maps, Google Analytics, WhatsApp y redes sociales. Persianas Toldos Málaga no asume responsabilidad alguna sobre los contenidos, servicios o políticas de privacidad de dichos sitios web.
                </p>
                <p>
                  La inclusión de un enlace a un sitio web de terceros no implica necesariamente que exista una relación de colaboración o patrocinio entre Persianas Toldos Málaga y el titular del sitio enlazado. El usuario accede a dichos sitios bajo su propia responsabilidad.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  7. Modificación del aviso legal
                </h2>
                <p className="mb-2">
                  Persianas Toldos Málaga se reserva el derecho a modificar las presentes condiciones en cualquier momento, publicando la versión actualizada en esta misma sección. Dichas modificaciones entrarán en vigor desde el momento de su publicación.
                </p>
                <p>
                  Se recomienda al usuario consultar periódicamente el presente Aviso Legal para mantenerse informado de las posibles modificaciones.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  8. Legislación aplicable y jurisdicción
                </h2>
                <p className="mb-2">
                  El presente Aviso Legal se rige en todos y cada uno de sus extremos por la legislación española. Para la resolución de cualquier controversia que pudiera derivarse del acceso o uso de este sitio web, el usuario y Persianas Toldos Málaga se someten expresamente a los Juzgados y Tribunales de la ciudad de Málaga, con renuncia expresa a cualquier otro fuero que pudiera corresponderles.
                </p>
                <p>
                  Última actualización: 20 de mayo de 2026.
                </p>
              </section>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}